import {toast} from 'react-toastify'
import {removePhonePlusOne} from './phoneUtils'

/**
 * Copies text to clipboard with automatic +1 removal for phone numbers
 * @param text The text to copy
 * @param fieldName The name of the field being copied (for toast messages)
 * @param rawText Optional raw text to use instead of the display text
 */
export const copyToClipboard = (
  text: string | null | undefined,
  fieldName: string,
  rawText?: string
): void => {
  const toCopy = rawText ?? text
  const trimmed = toCopy?.toString().trim()

  if (!trimmed) {
    toast.warning(`No ${fieldName} to copy`)
    return
  }

  // Remove +1 prefix if present (for phone numbers)
  const processedText = removePhonePlusOne(trimmed)

  navigator.clipboard.writeText(processedText).then(
    () => toast.success(`${fieldName} copied to clipboard`),
    () => toast.error('Failed to copy')
  )
}
